import EyeIcon from '@/shared/assets/icons/eye.svg?react'
import { FileModal } from '@/shared/components'
import { cn } from '@/shared/lib'
import { formatBytes, getBase64FileSize, getLinkName } from '@/shared/utils/downloadfile'
import { Button } from '@headlessui/react'
import { useState } from 'react'

export const Receipt = ({
  receiptFile,
  receiptType,
  mini = false,
}: {
  receiptFile?: string | null
  receiptType?: string | null
  receiptUrl?: string | null
  mini?: boolean
}) => {
  const [modalVisible, setModalVisible] = useState(false)

  const handleView = () => {
    if (receiptFile && receiptType) {
      setModalVisible(true)
    }
  }
  return (
    <>
      {receiptFile && receiptType ? (
        <Button
          className={cn(
            'flex items-center gap-[10px] bg-light-purple-hover dark:bg-primary-dark-hover rounded-full w-fit min-w-max font-medium text-left cursor-pointer',
            mini ? 'px-3 py-1' : 'px-4 py-2'
          )}
          onClick={handleView}
        >
          <EyeIcon className="text-primary shrink-0" />
          <div className="flex flex-col">
            <span className={cn('font-medium', mini ? 'text-sm' : 'text-base')}>
              {receiptType ? getLinkName(receiptType) : 'Документ'}
            </span>
            {!mini && (
              <span className="dark:text-card-border text-text-secondary text-sm">
                {formatBytes(getBase64FileSize(receiptFile))}
              </span>
            )}
          </div>
        </Button>
      ) : (
        <div className="flex items-center gap-[10px]">
          <EyeIcon className="text-[var(--status-purple-fill)] dark:text-[var(--status-purple-fill)] shrink-0" />
          <span className="font-medium">Прикрепленных документов нет</span>
        </div>
      )}

      {receiptFile && receiptType && (
        <FileModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          receiptFile={receiptFile}
          receiptType={receiptType}
        />
      )}
    </>
  )
}
